import React from "react";

const formatearFecha = (fecha) => {
  if (!fecha) return "";
  const date = new Date(fecha);
  if (Number.isNaN(date.getTime())) return String(fecha);
  return date.toLocaleString("es-CO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const AuditoriaTable = ({ registros }) => {
  if (!Array.isArray(registros) || registros.length === 0) {
    return (
      <div className="no-results">No se encontraron registros de auditoría.</div>
    );
  }

  return (
    <div className="table-container">
      <table className="cierre-turno-table">
        <thead>
          <tr>
            <th>id</th>
            <th>usuario</th>
            <th>accion</th>
            <th>fecha</th>
            <th>entidad_id</th>
            <th>terminal</th>
            <th>detalle</th>
          </tr>
        </thead>
        <tbody>
          {registros.map((row, index) => (
            <tr key={row.id || `${row.fecha}-${row.usuario}-${index}`}>
              <td>{row.id}</td>
              <td>{row.usuario}</td>
              <td>{row.accion}</td>
              <td>{formatearFecha(row.fecha)}</td>
              <td>{row.entidad_id}</td>
              <td>{row.terminal}</td>
              <td className="auditoria-detalle" title={row.detalle}>
                {row.detalle}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AuditoriaTable;
